import { Typography } from '@progress/kendo-react-common';
import { Button } from '@progress/kendo-react-buttons';
import { KWELLO_ICON, KwelloSvgIcon } from '../icon/KwelloSvgIcon';
import { Spinner } from '../loader/Spinner';
import { Card, CardBody, CardFooter } from '@progress/kendo-react-layout';
import { FilterParent } from '../../models/filter.model';
import { TabCardHeader } from './TabCardHeader';
import { INSIGHTS_ROUTES } from 'routes/routes.const';

const INSIGHTS_URL = INSIGHTS_ROUTES.summary;

export default function InsightsTab({
  data,
  isLoading,
  navigate,
  HeaderComponent,
  isTeamMember,
}: any) {
  if (isLoading) {
    return <Spinner />;
  }
  if (data.data.length === 0) {
    return (
      <div className="no-data">
        <KwelloSvgIcon icon={KWELLO_ICON.INFO_ROUNDED_ICON} />
        <Typography.p>No Insights History</Typography.p>
      </div>
    );
  }
  return (
    <div className="insights-tab">
      {HeaderComponent}
      <div className="tab-content">
        {data.data.map((row: any, index: number) => {
          return (
            <div className="insight-card" key={index}>
              <Card>
                <TabCardHeader row={row} isTeamMember={isTeamMember} />
                <CardBody>
                  <div className="card-response">
                    <div className="survey">{row.surveyName}</div>
                    <div>{row.question}</div>
                    <div className="answer-option-text">
                      <KwelloSvgIcon icon={KWELLO_ICON.DOWNLOAD_DONE} /> {row.response}
                    </div>
                    <div className="response-details">{row.responseDetails}</div>
                  </div>

                  <CardFooter>
                    <KwelloSvgIcon icon={KWELLO_ICON.TAG_OUTLINE_ICON} /> {row.tagCount}
                  </CardFooter>
                </CardBody>
              </Card>
            </div>
          );
        })}
        <div className="panel-footer">
          {/* eslint-disable-next-line @typescript-eslint/no-unsafe-return */}
          <Button
            rounded={'full'}
            onClick={(): void => {
              navigate(INSIGHTS_URL, true, FilterParent.SURVEY);
            }}
          >
            View All Insights <KwelloSvgIcon icon={KWELLO_ICON.FILE_FIND} />
          </Button>
        </div>
      </div>
    </div>
  );
}
